import { render } from "./MentalHealth.vue?vue&type=template&id=858c451c&scoped=true"
import script from "./MentalHealth.vue?vue&type=script&lang=js"
export * from "./MentalHealth.vue?vue&type=script&lang=js"

import "./MentalHealth.vue?vue&type=style&index=0&id=858c451c&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-858c451c"]])

export default __exports__